import React from "react";
import * as S from "./CabFeatureCard.styles";
import Icon from "../../../../core-components/IconsSelector";
import useCarousel from "../../../../../shared/containers/useCarousel/useCarousel";
import { gcHomeScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { CABS_LANDING_ROUTE, CAB_FEATURE_CARD, CAB_FEATURE_CAROUSEL_DECREMENT_CLICK, CAB_FEATURE_CAROUSEL_INCREMENT_CLICK } from "../../../../../shared/utils/util-constants";

type CabFeatureCardProps = {
  persuasion: Array<{ icon_img_url: string; txt: string }>;
};

const CabFeatureCard = ({ persuasion }: CabFeatureCardProps) => {
  if (!persuasion?.length) return null;
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(persuasion, 2);
  return (
    <S.CabsFeatureOuterWrap>
      <S.CabFeatureWrap left={isLeftCursorActive}>
        {dataList.map(({ icon, title }, index) => (
          <S.Card key={`cabFeature${index}`}>
            <img src={icon} height="26px" width="35px" alt="cabs" />
            <span>{title}</span>
          </S.Card>
        )) || null}
      </S.CabFeatureWrap>
      {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => {
            pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, CAB_FEATURE_CAROUSEL_INCREMENT_CLICK), CTA_TYPE.IMAGES, CAB_FEATURE_CARD, CABS_LANDING_ROUTE)
            increment();
          }}
          aria-label="Next Offer"
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => {
            pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, CAB_FEATURE_CAROUSEL_DECREMENT_CLICK), CTA_TYPE.IMAGES, CAB_FEATURE_CARD, CABS_LANDING_ROUTE)
            decrement();
          }}
          aria-label="Previous Offer"
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
    </S.CabsFeatureOuterWrap>
  );
};

export default CabFeatureCard;
